import CountUp from "./count-up"

function Stats(){
    return(
        <section className="stats-section">
            <h2>Our Performance at a Glance</h2>
            <div className="stats-grid">
                <div className="stat-box">
                    <i className="fas fa-briefcase"></i>
                    <CountUp end={11} duration={1000} />
                    <p>Years of Experience</p>
                </div>

                <div className="stat-box">
                    <i className="fas fa-truck-loading"></i>
                    <CountUp end={75000} duration={1000} />
                    <p>Shipments Delivered / Month</p>
                </div>

                <div className="stat-box">
                    <i className="fas fa-truck"></i>
                    <CountUp end={30} duration={1000} />
                    <p>Fleet Vehicles</p>
                </div>

                <div className="stat-box">
                    <i className="fas fa-map-marked-alt"></i>
                    <CountUp end={3} duration={1000} />
                    <p>States Covered</p>
                </div>

                <div className="stat-box">
                    <i className="fas fa-users"></i>
                    <CountUp end={100} duration={1000} />
                    <p>Employees</p>
                </div>
            </div>
        </section>

    );
}

export default Stats;